import uniqby from 'lodash.uniqby';
import DataTable from 'react-data-table-component';
import { translate } from 'react-switch-lang';

const TechnicianColumns = (props) => {
  const technicienColumns: any = [
    {
      name: props.t('username'),
      selector: (row) => row.name,
      sortable: false,
      center: true,
    },
    {
      name: props.t('first_name'),
      selector: (row) => row.nom,
      sortable: false,
      center: true,
    },
    {
      name: props.t('last_name'),
      selector: (row) => row.prenom,
      sortable: false,
      center: true,
    },
    {
      name: props.t('email'),
      selector: (row) => row.email,
      sortable: false,
      center: true,
    },
  ];

  return <DataTable columns={technicienColumns} data={uniqby(props.data, 'email')} />;
};

export default translate(TechnicianColumns);
